import { CommandBarButton, DirectionalHint, FontIcon, IChoiceGroupOption, IChoiceGroupOptionStyles, IComboBoxOption, IIconStyles, IOverflowSetItemProps, ITextFieldProps, TooltipHost } from "@fluentui/react"
import { SimmerProgressList } from "../../components/indicadores/Load"
import { IHeaderTitlesText } from "../../Interfaces/IPanel"
import COLORES from "../theme/colores"
import themeBase from "../theme/themeBase"

const HeaderPanelTiles: IHeaderTitlesText = {
    title: 'Nuevo IPERC Base',
    subTitle: 'Complete los campos para definir IPERC',
}
const IconAddStyles: IIconStyles = {
    root: {
        width: "30px",
        borderRadius: "30px",
        height: "30px",
        fontSize: "25px",
        background: COLORES.Icons.primary,
        color: "#fff"
    }
}

const NIVEL_OPTIONS: IComboBoxOption[] = [
    { key: "01", text: 'Alto', styles: { root: { color: themeBase.colors_IPERC.A } } },
    { key: "02", text: 'Medio', styles: { root: { color: themeBase.colors_IPERC.M } } },
    { key: "03", text: 'Bajo', styles: { root: { color: themeBase.colors_IPERC.B } } },
]

const StyleIChoiceGroupOptionA: IChoiceGroupOptionStyles = { root: { color: themeBase.colors_IPERC.A, marginRight: 10 } } //fontWeight: 'bold',
const StyleIChoiceGroupOptionM: IChoiceGroupOptionStyles = { root: { color: themeBase.colors_IPERC.M, marginRight: 10 } } //fontWeight: 'bold',
const StyleIChoiceGroupOptionB: IChoiceGroupOptionStyles = { root: { color: themeBase.colors_IPERC.B, marginRight: 10 } } //fontWeight: 'bold',
const StyleIChoiceGroupOptionMatriz: IChoiceGroupOptionStyles = { root: { color: themeBase.colors_IPERC.B, marginRight: 20 } } //fontWeight: 'bold',

const IPERC_CHOICE_OPTIONS: IChoiceGroupOption[] = [
    { key: "01", text: "Alto", styles: StyleIChoiceGroupOptionA },
    { key: "02", text: "Medio", styles: StyleIChoiceGroupOptionM },
    { key: "03", text: "Bajo", styles: StyleIChoiceGroupOptionB },
];

const IPERC_CHOICE_OPTIONS_MATRIZ: IChoiceGroupOption[] = [
    { key: "01", text: "A", styles: StyleIChoiceGroupOptionMatriz },
    { key: "02", text: "B", styles: StyleIChoiceGroupOptionMatriz },
    { key: "03", text: "C", styles: StyleIChoiceGroupOptionMatriz },
    { key: "04", text: "D", styles: StyleIChoiceGroupOptionMatriz },
    { key: "05", text: "E", styles: StyleIChoiceGroupOptionMatriz },
];
const IPERC_CHOICE_OPTIONS_MATRIZ2: IChoiceGroupOption[] = [
    { key: "01", text: "A", styles: StyleIChoiceGroupOptionMatriz },
    { key: "02", text: "B", styles: StyleIChoiceGroupOptionMatriz },
    { key: "03", text: "C", styles: StyleIChoiceGroupOptionMatriz },
    { key: "04", text: "D", styles: StyleIChoiceGroupOptionMatriz },
    { key: "05", text: "E", styles: StyleIChoiceGroupOptionMatriz },
    { key: "06", text: "A", styles: StyleIChoiceGroupOptionMatriz },
    { key: "07", text: "B", styles: StyleIChoiceGroupOptionMatriz },
    { key: "08", text: "C", styles: StyleIChoiceGroupOptionMatriz },
    { key: "09", text: "D", styles: StyleIChoiceGroupOptionMatriz },
    { key: "10", text: "E", styles: StyleIChoiceGroupOptionMatriz },
];

const TextFieldMultilineProps: ITextFieldProps = {
    className: "ms-depth-4",
    resizable: false,
    required: true,
    multiline: true,
    borderless: true,
}
const TextTextFieldElevation: ITextFieldProps = {
    resizable: false,
    borderless: true,
    className: "ms-depth-8 ms-fontColor-themePrimary--hover",
    styles: {
        prefix: { background: '#fff' },
        fieldGroup: { minHeight: 45, color: COLORES.IPERC.M },
    },
    onRenderPrefix:(arg) => (<FontIcon iconName="Rename" style={{ color: COLORES.Bases.primary }} />)

}

const StyleIndicador = {
    field: {
        fontWeight: 'bold',
        color: themeBase.colors_IPERC.number,
        borderBottom: 'Solid 1px #edebe9'
    },
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const TextFieldNumberProps: ITextFieldProps = {
    resizable: false,
    borderless: true,
    prefix: "Indicador *",
    type: "number",
    min: 0,
    max: 25,
    styles: StyleIndicador,
    iconProps: { iconName: 'NumberField' },
}
const TextFieldNumberProps1: ITextFieldProps = {
    resizable: false,
    borderless: true,
    type: "number",
    min: 0,
    max: 25,
    styles: StyleIndicador,
    iconProps: { iconName: 'NumberField' },
}

 const onRenderOverflowButton = (overflowItems: any[] | undefined): JSX.Element => {
    return (
        <TooltipHost content="Opciones" directionalHint={DirectionalHint.rightCenter}>
            <CommandBarButton
                aria-label="More items"
                menuIconProps={{ iconName: 'MoreVertical' }}
                menuProps={{ items: overflowItems! }}
                styles={{ root: { background: "none" } }}
            />
        </TooltipHost>
    );
};

const onRenderItem = (item: IOverflowSetItemProps): JSX.Element => {
    return (
        <TooltipHost content={item.title} directionalHint={DirectionalHint.leftCenter}>
            <CommandBarButton
                aria-label={item.name}
                iconProps={{ iconName: item.icon }}
                onClick={item.onClick}
                styles={{ root: { background: "none" } }}
            />
        </TooltipHost>
    );
};

export const CODIGO = {
    ALTO: "01",
    MEDIO: "02",
    BAJO: "03"
}

export function validaIntervalo(value: number): number {
    if (value > 25)
        return 25
    if (value < 1)
        return 1
    return value
}

export function _indicadorByChoiceKey(key: string) {
    let resul = 25
    switch (key) {
        case "01":
            resul = 1
            break;
        case "02":
            resul = 9
            break;
        case "03":
            resul = 16
            break;
        default:
            resul = 25
            break;
    }
    return resul
}

export function validaOpcion(indicador: number): string {
    return (indicador > 8 ? (indicador > 15 ? CODIGO.BAJO : CODIGO.MEDIO) : CODIGO.ALTO)
}

const LoadingData = (isLoadingData) => {
    if (!isLoadingData)
        return <>
            <SimmerProgressList disabled={false} />
            <SimmerProgressList disabled={false} />
            <SimmerProgressList disabled={false} />
            <SimmerProgressList disabled={false} />
        </>
    if (isLoadingData)
        return null
}

const HelpersIpercBase = {
    HeaderPanelTiles,
    TextTextFieldElevation,
    IconAddStyles,
    NIVEL_OPTIONS,
    IPERC_CHOICE_OPTIONS,
    IPERC_CHOICE_OPTIONS_MATRIZ,
    IPERC_CHOICE_OPTIONS_MATRIZ2,
    TextFieldMultilineProps,
    TextFieldNumberProps,
    TextFieldNumberProps1,
    onRenderOverflowButton,
    onRenderItem,
    LoadingData,
}

export default HelpersIpercBase